import type {ReactNode} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {H3} from '../typography'
import {popoverStyle, content} from './popover.module.scss'

type Props = {
  id: string
  title?: ReactNode
  className?: string
  dataTest?: string | null
  /* Content of the Popover */
  children: ReactNode
}

export function Popover(props: Props) {
  const titleNode =
    props.title !== null && props.title !== undefined ? <H3>{props.title}</H3> : null
  const className = addMaybeClassName(popoverStyle, props.className)
  return (
    <div id={props.id} className={className} data-test={props.dataTest}>
      {titleNode}
      <div className={content}>{props.children}</div>
    </div>
  )
}
